export const scrollToSection = (
    element: React.RefObject<HTMLDivElement>,
    scrollableRef?: React.RefObject<HTMLElement>,
    offsetRef?: React.RefObject<HTMLElement>,
    additionalPadding = 8,
) => {
    if (!element.current) {
        return;
    }

    if (!scrollableRef) {
        element.current.scrollIntoView({ behavior: 'smooth' });
        return;
    }

    if (!scrollableRef.current) {
        return;
    }

    setTimeout(() => {
        const targetElement = element.current;
        const scrollContainer = scrollableRef.current;

        if (!targetElement || !scrollContainer) {
            return;
        }

        if (!offsetRef?.current) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
            return;
        }

        const offsetHeight = offsetRef.current.offsetHeight;
        const targetRect = targetElement.getBoundingClientRect();
        const containerRect = scrollContainer.getBoundingClientRect();
        const offsetTop =
            targetRect.top -
            containerRect.top +
            scrollContainer.scrollTop -
            offsetHeight -
            additionalPadding;

        scrollContainer.scrollTo({
            top: Math.max(0, offsetTop),
            behavior: 'smooth',
        });
    }, 10);
};
